import { render, staticRenderFns } from "./MyPastDueLandownerReports.vue?vue&type=template&id=44252524"
import script from "./MyPastDueLandownerReports.vue?vue&type=script&lang=js"
export * from "./MyPastDueLandownerReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports